
import { cn } from '@/lib/utils';
import { truncateBody } from '@/lib/format';
import type { PrayerFormData } from '@/lib/validation';

interface PrayerFormRecapProps {
  formData: PrayerFormData;
  className?: string;
}

export function PrayerFormRecap({ formData, className }: PrayerFormRecapProps) {
  const isPraise = String(formData.type) === 'praise_report';
  const typeLabel = isPraise ? 'Answered Prayer' : 'Prayer Request';
  const preview = truncateBody(formData.body);

  if (!preview) return null;

  return (
    <div
      className={cn(
        'rounded-lg border border-slate-200/80 dark:border-slate-700/80',
        'bg-white/60 dark:bg-slate-800/40 px-4 py-3',
        className
      )}
    >
      <p className="text-xs font-medium text-primary-600 dark:text-primary-400 mb-1">
        {typeLabel}
      </p>
      <p className="text-sm text-slate-600 dark:text-slate-400 italic line-clamp-2">
        &ldquo;{preview}&rdquo;
      </p>
    </div>
  );
}
